export type EquivalentSortKey = "price" | "name" | "stock";

export interface SortableEquivalent {
  name: string;
  stock: number | null;
  rev4_price?: number | null;
}

export function sortEquivalents<T extends SortableEquivalent>(
  equivalents: T[],
  sortBy: EquivalentSortKey,
): T[] {
  const sorted = [...equivalents];
  switch (sortBy) {
    case "price":
      sorted.sort((a, b) => {
        const pa = a.rev4_price ?? Number.POSITIVE_INFINITY;
        const pb = b.rev4_price ?? Number.POSITIVE_INFINITY;
        return pa - pb;
      });
      break;
    case "name":
      sorted.sort((a, b) => a.name.localeCompare(b.name, "pt"));
      break;
    case "stock":
      sorted.sort((a, b) => (b.stock ?? 0) - (a.stock ?? 0));
      break;
  }
  return sorted;
}
